import axios, {
  AxiosPromise,
} from 'axios';
import { OsmosisTranscriptDto } from './osmosis-service.dtos';

export const fetchOsmosisTranscript = (learnName: string, auth: string): AxiosPromise<OsmosisTranscriptDto> => {
  return axios.get(`https://www.osmosis.org/api/learn/transcripts?learnName=${encodeURIComponent(learnName)}&auth=${auth}`);
};
